import React, { Component } from 'react';
import avatar from './avatar.gif';
import ProjectEntry from "./ProjectEntry";
import './App.css';

class App extends Component {
  render() {
    return (
      <div className="App">
        <header className="App-header">
          {/*<img src={avatar} className="App-logo" alt="logo" />*/}
          <h1 className="App-title">Jacob MacDonald</h1>
        </header>
        <div style={{
          height: "50px",
          backgroundColor: "var(--dark-blue)",
          display: "grid",
          gridTemplateColumns: "20px min-content min-content min-content min-content auto",
          gridTemplateRows: "auto min-content auto",
          whiteSpace: "nowrap",
          gridColumnGap: "20px",
          color: "var(--cyan)",
          position: "sticky",
          zIndex: 4,
          top: "0px",
        }}>
          <a href="https://jacobmacdonald.me" className="titleLink" style={{ gridColumn: "2" }}>Jacob MacDonald</a>
          <a href="https://github.com/macdja38" className="titleLink" style={{ gridColumn: "3" }}>Github</a>
          <a href="https://www.linkedin.com/in/jacob-macdonald/" className="titleLink"
             style={{ gridColumn: "4" }}>Linkedin</a>
          <a href="https://keybase.io/macdja38" className="titleLink" style={{ gridColumn: "5" }}>Keybase</a>
        </div>
        <div className="App-intro">
          <div className="Content-grid">
            <ProjectEntry
              text="PvPCraft is a discord bot used on over 50k chat servers with an impact easily in the millions."
              link="https://bot.pvpcraft.ca"
              github="https://github.com/macdja38/pvpcraft"
            />
            <ProjectEntry
              text="Ryke is a hackathon entry designed to allow students to explore the
                campus in 3d using a leap motion controller."
              link="https://ryke.xyz"
              github="https://github.com/macdja38/ryke"
            />
            <ProjectEntry
              text="Christmas Spirit is a website and discord bot that allow users to
                position a christmas hat on their avatar."
              link="https://mlh.ryke.xyz/"
              github="https://github.com/macdja38/mlhfall-client"
            />
            <ProjectEntry
              text="Lunar storage is a hackathon project designed to facilitate inventory
                management with expiring items and a limit storage space."
              link="http://wecameforthefood.me"
              github="https://github.com/macdja38/wecameforthefood-client"
            />
            <ProjectEntry
              text="IMMM is a resume management system that allows users to upload resumes
                and managers to search them."
              link="https://hack.ryke.xyz/"
              github="https://github.com/ITrippleM/ClientSide"
            />
          </div>
        </div>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js